import { observer } from 'mobx-react-lite';
import * as React from 'react';
import OtherDayCard from './OtherDayCard';
import TodayCard from './TodayCard';
import weatherStore from '../store';
import { TemperatureData } from './WeatherAnimation';
let styles = require('./WeatherCard.scss');
const spriteStyles = require('owa-sprite/dist/styles/weatherLargeFlat_sprite.css');
const iconClassPrefix = 'weatherLargeFlat-icon-SkyCode_';

/**
 * Props for Weather callout content
 */
export interface WeatherCardContentProps {
    daysFromToday: number;
}

/**
 * Component for rendering weather callout information in peek
 */
export default observer(function WeatherCardContent(props: WeatherCardContentProps) {
    let { daysFromToday } = props;
    let locationIndex = weatherStore.currentLocationIndex;
    let currentLocation = weatherStore.weatherLocations[locationIndex];
    let dayForcast = currentLocation.MultidayForecast.DailyForecasts[daysFromToday];
    let iconClass = daysFromToday
        ? spriteStyles[iconClassPrefix + dayForcast.SkyCode]
        : spriteStyles[iconClassPrefix + currentLocation.Conditions.SkyCode];
    let attribution = currentLocation.Conditions.Attribution.Text;
    const temperatureData: TemperatureData = {
        currentTemp: daysFromToday == 0 ? currentLocation.Conditions.Temperature : null,
        weatherString: daysFromToday == 0 ? currentLocation.Conditions.SkyText : dayForcast.SkyText,
        tempHigh: dayForcast.High,
        tempLow: dayForcast.Low,
        precipitation: dayForcast.PrecipitationChance,
    };
    if (daysFromToday !== 0) {
        let icon = iconClass ? iconClass : spriteStyles[iconClassPrefix + 0];
        return (
            <OtherDayCard
                styles={styles}
                iconClass={icon}
                temperatureData={temperatureData}
                attribution={attribution}
                locationIndex={locationIndex}
            />
        );
    } else {
        return (
            <TodayCard
                styles={styles}
                iconClass={iconClass}
                temperatureData={temperatureData}
                attribution={attribution}
                locationIndex={locationIndex}
            />
        );
    }
});
